import React from "react";
import { socket } from "../../../lib/socketio";
import { GroupTemplate } from "../../Definitions/cl";
import { Grid, Label } from "semantic-ui-react";
import VSDColumn from "../../Monitor/Data/VSDColumns";
import Footer from "../Footer";

import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import { useLocation } from "react-router-dom";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../actions/navActions";

const VSDFBPSM4 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 207 }, { display_id: 130 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
      return () => {
        socket.removeAllListeners();
      };
    }
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'Footer' ? [t] : []);
    t.display_id === 130 ? [t] : [],
  );
  const GenTags = tags.flatMap((t) => (t.display_id === 207 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);
  const VSDTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const columns = [];
  const length = VSDTags[0].length;
  const rows = Math.round(length / 4);
  let i = 0;
  while (i < length) {
    columns.push(VSDTags[0].slice(i, i + rows));
    i += rows;
  }

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
      <div style={styles.div}>
        {!electronApp && pop && (
            <RequestAccessModal
                pop={pop}
                yes={handleYes}
                no={handleNo}
                reqq={requestor.split(":")[0]}
            />
        )}
        <p style={{alignSelf: 'flex-end'}}> Normal
          <Label circular horizontal empty size='large' color='green' style={{marginLeft: '5px'}}/>
        </p>
        <p style={{alignSelf: 'flex-end'}}> Warning/Fault
          <Label circular horizontal empty size='large' color='red' style={{marginLeft: '5px'}}/>
        </p>
        <h1 style={styles.header}>{display[0]}</h1>
        <Grid inverted divided centered columns="equal" style={styles.grid}>
          {columns.length > 5 ? (
              <>
                <Grid.Row>
                  {columns.slice(0, Math.ceil(columns.length / 2)).map((c, i) => (
                      <VSDColumn index={i} column={c} data={data}/>
                  ))}
                </Grid.Row>
                <Grid.Row>
                  {columns.slice(Math.ceil(columns.length / 2)).map((c, i) => (
                      <VSDColumn index={i} column={c} data={data}/>
                  ))}
                </Grid.Row>
              </>
          ) : (
              columns.map((c, i) => <VSDColumn index={i} column={c} data={data}/>)
          )}
        </Grid>
        <Footer tags={FooterTags} data={data}/>
      </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "25px",
  },
};

export default VSDFBPSM4;
